import { withSvgProps } from './helpers'
import { ReactComponent as SvgComponent } from './svg/sign-up.svg'

type SvgProps = React.ComponentProps<typeof SvgComponent>

const Svg: React.FC<SvgProps> = (props) => <SvgComponent {...props} />

export const SignUp = withSvgProps(Svg)
